import { datadogRum } from '@datadog/browser-rum';
import { isBrowser } from '../shared/Utils';
import { FeatureToggleName } from './featureToggles.types';

/**
 * Whether Datadog RUM runs on this build. Must match the condition under which
 * `Header` calls `datadogRum.init` (prod builds only). Calls made before init
 * finishes are buffered by the SDK and sent once it starts.
 */
export const isRumEnabled = (): boolean =>
    // Referenced literally so Gatsby's DefinePlugin can inline it.
    isBrowser && process.env.GATSBY_DD_RUM_ENV === `prod-reach`;

/** Record a toggle evaluation in RUM. Never throws; no-op when RUM is off. */
export const logFeatureFlagEvaluation = (
    name: FeatureToggleName,
    value: boolean,
): void => {
    if (!isRumEnabled()) return;
    try {
        datadogRum.addFeatureFlagEvaluation(name, value);
    } catch {
        // Observability must never affect toggle behavior.
    }
};

/** Report a feature toggle failure to RUM. Never throws. */
export const logFeatureToggleError = (error: unknown): void => {
    if (!isRumEnabled()) return;
    try {
        datadogRum.addError(error, { source: `featureToggles` });
    } catch {
        // Observability must never affect toggle behavior.
    }
};
